module.exports = __webpack_public_path__ + "static/media/bottom-left.419e5957.svg";